module.exports = __webpack_public_path__ + "assets/img/young_program_2.5c7ec47e.png";